import React, { useEffect, useState } from "react";
import './UserRequest.css';

const UserRequest = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all requests when the component mounts
  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await fetch("https://back.varankal.com/api/submit-request/all-requests");
        const data = await response.json();
        if (data.success) {
          setRequests(data.data); // Update state with the fetched requests
        } else {
          console.error("Failed to fetch requests");
        }
      } catch (error) {
        console.error("Error fetching requests:", error);
      } finally {
        setLoading(false); // Stop the loading spinner when fetch is complete
      }
    };

    fetchRequests();
  }, []); // Run only once when the component mounts

  // Handle approve request
  const handleApprove = async (id) => {
    try {
      const response = await fetch("https://back.varankal.com/api/submit-request/update-status", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, status: "approved" }),
      });
      const data = await response.json();
      if (data.success) {
        console.log("Request approved:", data.data);
        // Update the UI accordingly
        setRequests(prevRequests =>
          prevRequests.map(request =>
            request._id === id ? { ...request, status: "approved" } : request
          )
        );
      }
    } catch (error) {
      console.error("Error approving the request:", error);
    }
  };

  // Handle reject request
  const handleReject = async (id) => {
    try {
      const response = await fetch("https://back.varankal.com/api/submit-request/update-status", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, status: "rejected" }),
      });
      const data = await response.json();
      if (data.success) {
        console.log("Request rejected:", data.data);
        // Update the UI accordingly
        setRequests(prevRequests =>
          prevRequests.map(request =>
            request._id === id ? { ...request, status: "rejected" } : request
          )
        );
      }
    } catch (error) {
      console.error("Error rejecting the request:", error);
    }
  };

  return (
    <div className="requests-containerOO">
      <h2>Submitted Requests</h2>
      {loading ? (
        <p className="loadingOO">Loading requests...</p>
      ) : requests.length === 0 ? (
        <p className="no-requestsOO">No requests available.</p>
      ) : (
        <table className="requests-tableOO">
          <thead>
            <tr>
              <th>Subject</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Issue Type</th>
              <th>Message</th>
              <th>Description</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request._id} className={`request-rowOO ${request.status}`}>
                <td>{request.subject}</td>
                <td>{request.email}</td>
                <td>{request.phone}</td>
                <td>{request.issueType}</td>
                <td>{request.message}</td>
                <td>{request.description}</td>
                <td>{request.status}</td>
                <td className="actionsOO">
                  {request.status === "pending" && (
                    <>
                      <button onClick={() => handleApprove(request._id)} className="approve-buttonOO">Approve</button>
                      <button onClick={() => handleReject(request._id)} className="reject-buttonOO">Reject</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserRequest;
